"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ModelCompositorAcreage_1 = __importDefault(require("./ModelCompositorAcreage"));
const ModelCompositorCrop_1 = __importDefault(require("./ModelCompositorCrop"));
class ModelCompositorGisArea {
    constructor(data) {
        this.project_id = data.project_id || -1;
        this.gis_area_id = data.gis_area_id || -1;
        this.type = data.type || '';
        this.category = data.category || '';
        this.score = data.score || -1;
        this.due_date = data.due_date || '';
        this.crop = new ModelCompositorCrop_1.default(data.crop);
        this.areaName = data.areaName || '';
        this.acreage = new ModelCompositorAcreage_1.default(data.acreage);
        this.visibility = data.visibility || false;
        this.is_synthetic = data.is_synthetic || false;
    }
    getProjectId() {
        return this.project_id;
    }
    getGisAreaId() {
        return this.gis_area_id;
    }
    getType() {
        return this.type;
    }
    getCategory() {
        return this.category;
    }
    getScore() {
        return this.score;
    }
    getDate() {
        return this.due_date;
    }
    addDecreaseDate(meses) {
        const fechaOriginal = new Date(this.due_date);
        fechaOriginal.setMonth(fechaOriginal.getMonth() + meses);
        return fechaOriginal.toISOString().slice(0, 19).replace('T', ' ');
    }
    getCrop() {
        if (this.getCrop()) {
            return new ModelCompositorCrop_1.default(this.getCrop());
        }
    }
    getAreaName() {
        return this.areaName;
    }
    getAcreage() {
        return new ModelCompositorAcreage_1.default(this.acreage);
    }
    getVisivility() {
        return this.visibility;
    }
    getIsSynthetic() {
        return this.is_synthetic;
    }
}
exports.default = ModelCompositorGisArea;
